import Input from './Input';
import InputMask from './InputMask';
import InputPassword from './InputPassword';
import InputVariant from './InputVariant';

Input.Mask = InputMask;
Input.Password = InputPassword;

export { Input, InputVariant };
